import Vue from 'vue'
import Router from 'vue-router'

import defaultscene from '@/scenes/defaultscene'
import pageScene from '@/scenes/pageScene'
import backgroundList from '@/scenes/pages/backgroundList'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'defaultscene',
      component: defaultscene,
      props: true
    },
    {
      path: '/backgrounds',
      name: 'backgrounds',
      component: backgroundList
    }
    // {
    //   path: '/:page',
    //   name: 'pageScene',
    //   component: pageScene,
    //   props: true
    // }
    // {
    //   path: '/courses/:id', // courses should be based on every available product type here
    //   name: 'productScene',
    //   component: productScene,
    //   props: true // should @page be set here? is undefined now
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js